export default "__VITE_ASSET__DwBiCLrD__"